import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Quotation } from '../../../../../../shared/types/modules/quotation';

export const useQuotationRegisterHistory = (quotationl?: Quotation) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = quotationl || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [quotationl]);

    return {
        formik,
    };
};
